import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { TAddCardPayload, TBillingAddressPayload } from './types';

export const addCardThunk = createAsyncThunk(
    'billing/addCardThunk',
    async (data:TAddCardPayload, { rejectWithValue }) => {
        try {
            const response: AxiosResponse<any> = await axios.post(`/pay/payment-process`, data)
            return response.data
        } catch (err) {
            return rejectWithValue((err as any).response.data)
        }
    }
)

export const updateCardThunk = createAsyncThunk(
    'billing/updateCardThunk', 
    async(data:TAddCardPayload,{rejectWithValue})=>{
        try{
            const response:AxiosResponse<any> = await axios.post('bill/processupdate',data); 
        }catch(err){
            return rejectWithValue((err as any).response.data);
        }
    }
)

export const getBillingDetailsThunk = createAsyncThunk(
    'billing/getBillingDetailsThunks',
    async(data,{rejectWithValue})=>{
        try{
            const response: AxiosResponse<any> = await axios.post('bill/billing',{})
            return response.data.data; 
        }catch(err){
            return rejectWithValue((err as any).response.data);
        }
    }
)

export const saveBillingAddressThunk = createAsyncThunk(
    'billing/saveBillingAddress',
    async(data:TBillingAddressPayload,{rejectWithValue})=>{
        try{
            const response = await axios.post('bill/billupdate',data); 
            return response.data; 
        }catch(err){
            return rejectWithValue((err as any).response.data);
        }
    }
)

export const initSubscritionThunk = createAsyncThunk(
    'billing/initSubscription',
    async (data,{rejectWithValue})=>{
        try{
            const response:AxiosResponse<any> = await axios.post('pay/sub',{}); 
            return response.data; 
        }catch(err){
            return rejectWithValue((err as any).response.data);
        }
    }
)
